import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import FluidAvatarImage from '../fluid-avatar-image';
import styles from './header-avatar-image.scss';

const IMAGE_SIZE = parseInt(styles.IMAGE_SIZE, 10) * 2;

const HeaderAvatarImage = ({ user }) => (
  <div className={classNames(styles.container, 'header-avatar-image')}>
    <div className={styles.image}>
      <FluidAvatarImage image={user.image} size={IMAGE_SIZE} />
    </div>
  </div>
);

HeaderAvatarImage.propTypes = {
  user: PropTypes.object.isRequired,
};

export default HeaderAvatarImage;
